var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.averagePrice != null)?_c('p',{staticClass:"title is-6 has-text-dark mb-0"},[_vm._v(" Average price of filtered listings: £"+_vm._s(_vm.formattedPrice)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }